import React, {useEffect, useRef, useState} from "react";
import { useNavigate } from "react-router-dom";
import TourCardIndividual from "../../../components/TourCard/TourCardIndividual";
import s from "./ComboOfferCard.module.scss";

const ComboOfferCard = ({ combo }) => {
    const navigate = useNavigate();

    const scrollerRef = useRef(null);

    const [activeDot, setActiveDot] = useState(0);

    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        const updateDots = () => {
            if (!scrollerRef.current) return;

            const { scrollWidth, clientWidth } = scrollerRef.current;

            if (clientWidth <= 0) {
                setDotCount(1);
                return;
            }

            const pages =
                Math.ceil(
                    (scrollWidth - clientWidth) / clientWidth
                ) + 1;

            setDotCount(Math.max(1, pages));
        };

        updateDots();

        window.addEventListener("resize", updateDots);

        return () =>
            window.removeEventListener("resize", updateDots);

    }, [combo]);
    const formatPrice = (price) =>
        new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "AUD",
            minimumFractionDigits: 2,
        }).format(price);

    const totalSalePrice = combo.tours.reduce(
        (sum, tour) => sum + Number(tour.sale_price || 0),
        0
    );
    const calculateFinalPrice = (value, amount) => {
        if (!value) return amount;

        let discount;

        if (String(value).includes("%")) {
            const percentage = parseFloat(value.replace("%", ""));
            discount = (amount * percentage) / 100;
        } else {
            discount = Number(value);
        }

        return amount - discount;
    };
    const comboPrice = calculateFinalPrice(
        combo.combo_price, // example: "5%" or "5"
        totalSalePrice
    );


    const handleScroll = () => {
        const el = scrollerRef.current;
        if (!el) return;

        const maxScroll =
            el.scrollWidth - el.clientWidth;

        if (maxScroll <= 0) {
            setActiveDot(0);
            return;
        }

        const progress = el.scrollLeft / maxScroll;

        const index = Math.round(
            progress * (dotCount - 1)
        );

        setActiveDot(index);
    };

    const onMouseDown = (e) => {
        const slider = scrollerRef.current;

        setIsDown(true);
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
    };

    const onMouseMove = (e) => {
        if (!isDown) return;

        e.preventDefault();

        const slider = scrollerRef.current;

        const x = e.pageX - slider.offsetLeft;

        slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    };

    const showDiscount =
        combo.show_discout === 1 &&
        combo.promo_code &&
        combo.promo_code.trim() !== "" &&
        combo.combo_price &&
        combo.combo_price.trim() !== "";

    return (
        <div className={s.comboCard}>

            <div className={s.comboHeader}>
                <h4>{combo.name}</h4>
            </div>

            <div className={s.comboContent}>

                <div className={s.toursSection}>

                    <div
                        ref={scrollerRef}
                        className={s.tourScroller}
                        onScroll={handleScroll}
                        onMouseDown={onMouseDown}
                        onMouseMove={onMouseMove}
                        onMouseUp={() => setIsDown(false)}
                        onMouseLeave={() => setIsDown(false)}
                    >
                        {combo.tours.map((tour, index) => (
                            <React.Fragment key={tour.tour_id}>
                                <div className={s.tourItem}>
                                    <TourCardIndividual item={tour} />
                                </div>

                                {index < combo.tours.length - 1 && (
                                    <div className={s.plusWrapper}>
                                        <span className={s.plus}>+</span>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <div className={s.dotContainer}>
                        {Array.from({ length: dotCount }).map((_, index) => (
                            <span
                                key={index}
                                className={`${s.dot} ${
                                    activeDot === index ? s.activeDot : ""
                                }`}
                            />
                        ))}
                    </div>

                </div>

                <div className={s.summarySection}>

                    <div className={s.priceSection}>

                        {showDiscount && (  <div className={s.priceRow}>
                            <span>総額</span>
                            <span className={s.originalPrice}>
                                {formatPrice(totalSalePrice)}
                            </span>
                        </div>)}

                        <div className={s.priceRow}>
                            <span>{showDiscount ? 'お得価格':'総額'}</span>
                            <span className={s.comboPrice}>
                                {showDiscount ? formatPrice(comboPrice):formatPrice(totalSalePrice)}
                            </span>
                        </div>

                        {showDiscount && (  <div className={s.saving}>
                            {formatPrice(
                                totalSalePrice - Number(comboPrice)
                            )}{" "}
                            お得です。
                        </div>)}

                    </div>

                    <button
                        className={s.bookBtn}
                        onClick={() =>
                            navigate(`/combo/${combo.id}`)
                        }
                    >
                        {combo.tours.length}点カートに追加する
                    </button>

                </div>

            </div>

        </div>
    );
};

export default ComboOfferCard;